import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { CompanyLegalDetails } from '../components/CompanyLegalDetails';
import { ContactForm } from '../components/ContactForm';
import { DashboardLayout } from '../components/DashboardLayout';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { useAuth } from '../context/AuthContext';
import { ETAPPIO_COMPANY } from '../constants/company';
import { sanitizeSupportContext } from '../utils/supportContext';

export function Contact() {
  const { t } = useTranslation();
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const context = sanitizeSupportContext(location.state?.supportContext);

  useEffect(() => {
    window.document.title = t('contactPage.documentTitle');
  }, [t]);

  const content = (
    <div className="container contact-page py-4 py-md-5">
      <h1 className="fw-bold mb-3">{t('contactPage.title')}</h1>
      <p className="lead text-muted mb-4">{t('contactPage.intro')}</p>
      <div className="row g-4 align-items-start">
        <div className="col-lg-7">
          <section className="bg-white border rounded-4 p-3 p-md-4">
            <h2 className="h4 mb-3">{t('contactPage.helpTitle')}</h2>
            <ContactForm key={user?.id ?? 'public'} context={context} />
          </section>
        </div>
        <div className="col-lg-5">
          <CompanyLegalDetails showContactPageLink={false} />
          <a className="contact-touch-link d-inline-flex align-items-center mt-3" href={`mailto:${ETAPPIO_COMPANY.email}`}>
            {t('contactPage.emailCta')}
          </a>
        </div>
      </div>
    </div>
  );

  if (isLoading) return <p role="status" className="p-4">{t('support.loading')}</p>;
  if (user) return <DashboardLayout>{content}</DashboardLayout>;

  return (
    <div className="min-vh-100 bg-light d-flex flex-column">
      <header className="bg-white border-bottom py-3">
        <div className="container d-flex flex-wrap gap-3 align-items-center justify-content-between">
          <Link to="/" className="contact-touch-link d-flex align-items-center" aria-label={t('contactPage.homeAriaLabel')}>
            <img src="/assets/images/logo-full.png" alt="ETAPPIO" height="38" />
          </Link>
          <div className="d-flex align-items-center gap-2">
            <LanguageSwitcher />
            <Link to="/" className="btn btn-light-brand contact-touch-link">{t('contactPage.backHome')}</Link>
          </div>
        </div>
      </header>
      <main className="flex-grow-1">{content}</main>
      <footer className="bg-dark text-white py-4">
        <div className="container text-center">
          <CompanyLegalDetails variant="compact" theme="dark" showContactPageLink={false} />
        </div>
      </footer>
    </div>
  );
}
